var map = {
	"./ACE.png": 8481,
	"./FGF.png": 6170,
	"./FGF_Black.png": 7195,
	"./MILLCROFT_BAKING.png": 2899,
	"./SIMPLE_JOYS.png": 9916,
	"./SIMPLE_JOYS_last.png": 7957,
	"./STONEFIRE.png": 2607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5721;